<template>
  <div class="wrapper">
    <div class="tabbar l_flex_row_between">
      <div class="select-box l_flex_row_center">
        <div class="item l_flex_row">
          <div class="name">参赛身份</div>
          <el-select
            class="select"
            size="small"
            v-model="identity"
            placeholder="请选择"
          >
            <el-option
              v-for="item in identityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item l_flex_row_center">
          <div class="name">主题</div>
          <el-select
            class="select"
            size="small"
            v-model="identity"
            placeholder="请选择"
          >
            <el-option
              v-for="item in identityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item l_flex_row_center">
          <div class="name">类别</div>
          <el-select
            class="select"
            size="small"
            v-model="identity"
            placeholder="请选择"
          >
            <el-option
              v-for="item in identityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item l_flex_row_center">
          <div class="name">作品状态</div>
          <el-select
            class="select"
            size="small"
            v-model="identity"
            placeholder="请选择"
          >
            <el-option
              v-for="item in identityList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="btn l_flex_row_center">导出</div>
    </div>
    <div class="container">
      <work-item
        :obj="item"
        class="item"
        v-for="(item, index) in datalist"
        :key="index"
      ></work-item>
    </div>
    <div class="pagination l_flex_row_center">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="12"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import workItem from "@/components/workItem";
export default {
  name:'worklist',
  components: { workItem },
  props: {},
  data() {
    return {
      identityList: [
        {
          label: "全部",
          value: "全部",
        },
        {
          label: "读者",
          value: "读者",
        },
        {
          label: "机构",
          value: "机构",
        },
      ],
      subjectList: [
        {
          label: "全部",
          value: "全部",
        },
        {
          label: "读者",
          value: "读者",
        },
        {
          label: "机构",
          value: "机构",
        },
      ],
      categoryList: [
        {
          label: "全部",
          value: "全部",
        },
        {
          label: "读者",
          value: "读者",
        },
        {
          label: "机构",
          value: "机构",
        },
      ],
      statusList: [
        {
          label: "全部",
          value: "全部",
        },
        {
          label: "读者",
          value: "读者",
        },
        {
          label: "机构",
          value: "机构",
        },
      ],
      identity: "",
      currentPage:1,
      datalist:[],
      total: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    handleSizeChange(e) {
      //
    },
    handleCurrentChange(e) {
      //
      console.log('currentchange',e);
      this.currentPage = e;
      this.getWroklist();
    },
     getWroklist(){
       this.$mock.getWorkList(this.currentPage).then(res => {
         this.datalist = res.data.list;
         this.total = res.data.total;
         console.log('success', res);
       }).catch(err => {
         console.log('error',err);
       })
     },

     //
    async  gettest(){
        try {
          let res = await this.$mock.gettest();
          console.log('===',res);
        } catch (error) {
          console.log(error);
        }
     }
  },
  created() {
    this.getWroklist();
    // this.gettest();
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  // background-color: #fff;
  width: 1200px;
  margin: 0 auto;
  .tabbar {
    height: 80px;

    .item {
      font-size: 15px;
      margin-right: 20px;
      .select {
        margin-left: 10px;
        width: 120px;
      }
    }
    .btn {
      width: 75px;
      height: 28px;
      background: #3ac176;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .container {
    padding: 60px 40px;
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    border-radius: 5px;
    .item {
      width: calc((100% - 80px - (26px * 3)) / 4);
      margin-right: 26px;
      margin-bottom: 40px;
      margin-left: 0px;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
  .pagination{
    height: 100px;
  }
}
</style>